import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=05d99a9c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d99a9c')) {
      api.createRecord('05d99a9c', component.options)
    } else {
      api.reload('05d99a9c', component.options)
    }
    module.hot.accept("./Overview.vue?vue&type=template&id=05d99a9c&", function () {
      api.rerender('05d99a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/slxc/components/Overview.vue"
export default component.exports